// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { USER_MODULE, USER_URL } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { UserWaitingApprovalIndex } = lazily(() => import('pages/back-office/user/user-waiting-approval'))

const userWaitingApprovalRoutes: IRoute[] = [
  {
    path: USER_URL.WAITING_APPROVAL,
    component: UserWaitingApprovalIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: USER_MODULE,
      requireAuth: true,
      attrs: {
        label: 'user.waitingApproval',
        accessCodes: [442],
      },
    },
  },
]

export { userWaitingApprovalRoutes }
